import { offlineDb } from '@/lib/offline/db';
import { currentLocale } from '@/lib/i18n';
import {
  createOsmPlacesClient,
  disabledPlacesClient,
  type PlacesCache,
  type PlacesClient,
} from './osm-client';

export * from './osm-client';

export const OVERPASS_URL =
  import.meta.env.VITE_PLACES_OVERPASS_URL || 'https://overpass-api.de/api/interpreter';
export const NOMINATIM_URL =
  import.meta.env.VITE_PLACES_NOMINATIM_URL || 'https://nominatim.openstreetmap.org';

/** IndexedDB-backed cache; failures (private mode, quota) silently fall back to the network. */
const dexieCache: PlacesCache = {
  get: (key) => offlineDb.placesCache.get(key),
  set: async (key, value, savedAt) => {
    await offlineDb.placesCache.put({ key, value, savedAt });
  },
};

let client: PlacesClient | null = null;

export function getPlacesClient(): PlacesClient {
  client ??=
    (import.meta.env.VITE_PLACES_PROVIDER ?? 'osm') === 'none'
      ? disabledPlacesClient
      : createOsmPlacesClient({
          overpassUrl: OVERPASS_URL,
          nominatimUrl: NOMINATIM_URL,
          cache: dexieCache,
          language: currentLocale,
        });
  return client;
}

/** Test seam. */
export function setPlacesClientForTests(next: PlacesClient | null): void {
  client = next;
}
